(() => {
  const instances = new WeakMap();
  const init = gallery => {
    if (instances.has(gallery)) return;
    const abort = new AbortController();
    const signal = abort.signal;
    instances.set(gallery, abort);
    const viewport = gallery.querySelector('.hw-gallery__viewport');
    const track = gallery.querySelector('[data-hw-gallery]');
    const cursor = gallery.querySelector('[data-hw-cursor]');
    const previous = gallery.querySelector('[data-hw-previous]');
    const next = gallery.querySelector('[data-hw-next]');
    const slides = [...track.querySelectorAll('[data-hw-slide]')];
    const finePointer = matchMedia('(any-hover: hover) and (any-pointer: fine)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    if (slides.length < 2) {
      cursor.hidden = previous.hidden = next.hidden = true;
      return;
    }
    gallery.classList.add('hw-gallery--pointer-ready');
    track.querySelectorAll('img').forEach(image => { image.draggable = false; });
    let pressed = null;
    let pendingIndex = null;
    let settleTimer;
    const currentIndex = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
    const hideCursor = () => { cursor.dataset.visible = 'false'; };
    const syncControls = () => {
      const index = currentIndex();
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
    };
    const move = direction => {
      const index = pendingIndex ?? currentIndex();
      pendingIndex = Math.max(0, Math.min(slides.length - 1, index + direction));
      track.scrollTo({left: pendingIndex * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth'});
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => { pendingIndex = null; syncControls(); }, 180);
    };
    const followPointer = event => {
      if (!finePointer.matches || event.pointerType === 'touch' || event.target.closest('button, video, a') || gallery.dataset.hwVideoActive === 'true') { hideCursor(); return; }
      const bounds = viewport.getBoundingClientRect();
      const x = event.clientX - bounds.left;
      const y = event.clientY - bounds.top;
      cursor.style.setProperty('--hw-pointer-x', (x - 24) + 'px');
      cursor.style.setProperty('--hw-pointer-y', (y - 24) + 'px');
      cursor.dataset.direction = x < bounds.width / 2 ? 'previous' : 'next';
      cursor.dataset.visible = 'true';
    };
    track.addEventListener('pointerenter', followPointer, {signal});
    track.addEventListener('pointermove', followPointer, {signal});
    track.addEventListener('pointerleave', hideCursor, {signal});
    track.addEventListener('pointercancel', () => { pressed = null; hideCursor(); }, {signal});
    track.addEventListener('pointerdown', event => {
      pressed = {x: event.clientX, y: event.clientY, type: event.pointerType};
    }, {signal});
    track.addEventListener('click', event => {
      if (event.target.closest('button, video, a, input')) { pressed = null; return; }
      if (!finePointer.matches || !pressed || pressed.type === 'touch') return;
      const drag = Math.hypot(event.clientX - pressed.x, event.clientY - pressed.y);
      pressed = null;
      if (drag > 8) return;
      const bounds = track.getBoundingClientRect();
      move(event.clientX - bounds.left < bounds.width / 2 ? -1 : 1);
    }, {signal});
    previous.addEventListener('click', () => move(-1), {signal});
    next.addEventListener('click', () => move(1), {signal});
    gallery.querySelectorAll('[data-hw-thumb]').forEach(button => button.addEventListener('click', () => { pendingIndex = null; }, {signal}));
    track.addEventListener('scroll', () => {
      syncControls();
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => { pendingIndex = null; }, 180);
    }, {passive: true, signal});
    track.addEventListener('keydown', () => { pendingIndex = null; hideCursor(); }, {signal});
    document.addEventListener('scroll', event => {
      if (!gallery.contains(event.target)) hideCursor();
    }, {passive: true, capture: true, signal});
    window.addEventListener('blur', hideCursor, {signal});
    window.addEventListener('resize', () => { pendingIndex = null; hideCursor(); syncControls(); }, {passive: true, signal});
    finePointer.addEventListener('change', hideCursor, {signal});
    signal.addEventListener('abort', () => clearTimeout(settleTimer), {once: true});
    syncControls();
  };
  document.querySelectorAll('.hw-gallery').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.hw-gallery').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.hw-gallery').forEach(gallery => instances.get(gallery)?.abort()));
})();
